module.exports = __webpack_public_path__ + "static/media/logo_tiktok.11f0cbf7.svg";